// extracted by mini-css-extract-plugin
export default {"gapFlex":"Loader_gapFlex__HV+ll","containSkeleton":"Loader_containSkeleton__6y42r"};